<template>
  <a-data-table
    :items="filterPeopleData"
    :headers="headers"
    :items-per-page="10"
    style="width: 100%"
    :footer-props="{
      'items-per-page-text': $t('lblRowsPerPage'),
    }"
    :sort-desc="false"
    :must-sort="true"
  >
    <template v-slot:[`item.firstName`]="{ item }">
      <v-list-item style="min-width: 200px; max-width: 300px" class="pl-0">
        <v-list-item-avatar size="24">
          <v-img
            v-if="getUserPhoto(item.id)"
            contain
            :src="getUserPhoto(item.id)"
          ></v-img>
          <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-title style="white-space: normal">
          <!-- <span style="font-weight: 700" v-if="item.isDeleted">
            {{ item.firstName + " " + item.lastName }}</span
          > -->
          <router-link
            class="routeLink-name"
            :to="`/people/${item.id}/tenant/${tenantId}/search`"
          >
            {{ item.firstName + " " + item.lastName }}
          </router-link>
          <!-- <v-chip
            v-if="item.isDeleted"
            class="ml-2"
            x-small
            color="error"
            outlined
          >
            Deleted
          </v-chip> -->
        </v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <div style="color: #333333; word-break: break-word">{{ item.title }}</div>
    </template>
    <template v-slot:[`item.display_email`]="{ item }">
      <div style="color: #333333">{{ item.display_email }}</div>
    </template>
    <template v-slot:[`item.skills`]="{ item }">
      <div>
        <a-chip
          style="color: #333333"
          class="minute ma-1 py-0"
          dark
          small
          label
          v-for="skill in item.skills"
          :key="skill"
        >
          {{ skill || "not found" }}
        </a-chip>
      </div>
    </template>
  </a-data-table>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getSkillColor } from "../../utils/constant";

export default {
  name: "PeopleSearch",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    ...mapState({
      peopleList: (state) => state.people.peopleList,
    }),
    headers() {
      return [
        {
          text: this.$t("people.name"),
          align: "left",
          value: "firstName",
          class: "header header-text",
        },
        {
          text: this.$t("people.name"),
          align: " d-none",
          value: "lastName",
          class: "header header-text",
        },
        {
          text: this.$t("people.lblTitle"),
          align: "left",
          value: "title",
          class: "header header-text",
        },
        {
          text: this.$t("people.lblEmail"),
          align: "left",
          value: "display_email",
          class: "header header-text",
        },
        {
          text: this.$t("people.lblSkills"),
          align: "left",
          value: "skills",
          class: "header header-text",
          sortable: false,
        },
      ];
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    filterPeopleData() {
      return this.items.map((obj) => {
        return {
          ...obj,
          isDeleted: !this.peopleList.some((item) => item.id === obj.id),
        };
      });
    },
  },
  methods: {
    getSkillColor,
    getUserPhoto,
  },
};
function getUserPhoto(id) {
  const user = this.peopleList.find((u) => u.id === id);
  if (user) {
    return user.profilePhoto || null;
  }
  return null;
}
</script>

<style scoped>
.routeLink-name {
  cursor: pointer;
  font-weight: 700;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
</style>